import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
`;

export const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const Card = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 1.5rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0.5rem;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
`;

export const CardTitle = styled.span`
    font-size: 24px;
    font-weight: 600;
    color: #25272e;
`;

export const CardValue = styled.span`
    font-size: 2rem;
    font-weight: 700;
    color: #25272e;
`;

export const ChartsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
`;

export const ChartsRowSmall = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    align-items: stretch;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
    }
`;

export const Section = styled.div`
    background: #ffffff;
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
`;

export const SectionTitle = styled.h2`
    font-size: 1.25rem;
    font-weight: 700;
    color: #25272e;
    margin-bottom: 1rem;
`;

export const ChartContainer = styled.div`
    height: 300px;
    width: 100%;
`;

export const ChartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

export const ChartLegend = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: center;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #464646;
`;

export const LegendDot = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${(props) => props.color || '#73a4f7'};
`;

export const VisitProfileContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    margin-top: 1rem;
`;

export const VisitProfileCard = styled.div`
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const VisitProfileTitle = styled.span`
    font-size: 0.875rem;
    font-weight: 600;
    color: #464646;
`;

export const VisitProfileValues = styled.div`
    display: flex;
    gap: 2rem;
`;

export const VisitProfileValue = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const VisitProfileLabel = styled.span`
    font-size: 0.75rem;
    color: #9ba1a9;
`;

export const VisitProfileNumber = styled.span`
    font-size: 1.25rem;
    font-weight: 700;
    color: #25272e;
`;
